/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingPlatformTagKeysRequest extends models.BillingTagKeysRequest {
    getFixupPrototypeFunction() { return BillingPlatformTagKeysRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingPlatformTagKeysRequest>): BillingPlatformTagKeysRequest {
        let obj = Object.assign(new BillingPlatformTagKeysRequest(), model);
        BillingPlatformTagKeysRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingPlatformTagKeysRequest>): BillingPlatformTagKeysRequest {
        if (!model) return null;
        return BillingPlatformTagKeysRequest.newInstance(<BillingPlatformTagKeysRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingPlatformTagKeysRequest) {
        if (!obj) return;

        models.BillingPlatformTagKeysRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingPlatformTagKeysRequest): boolean {
        if (models.BillingTagKeysRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingPlatformTagKeysRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Billing Platform kinds
     */
    kinds: Array<string>;

}
